(function () {
  'use strict';

  if (window.__ossPredictiveSearchReady) return;
  window.__ossPredictiveSearchReady = true;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
    });
  }

  function formatPrice(value, currency) {
    var amount = Number(value || 0);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function priceLabel(product, currency) {
    var min = Number(product.price_min != null ? product.price_min : product.price);
    var max = Number(product.price_max != null ? product.price_max : product.price);
    if (!Number.isFinite(min)) return '';
    if (Number.isFinite(max) && max > min) {
      return formatPrice(min, currency) + ' - ' + formatPrice(max, currency);
    }
    return formatPrice(min, currency);
  }

  function init(form, index) {
    var input = form.querySelector('[data-oss-predictive-search-input]');
    var results = form.querySelector('[data-oss-predictive-search-results]');
    var endpoint = form.getAttribute('data-predictive-search-url');
    var currency = form.getAttribute('data-money-currency') || document.documentElement.getAttribute('data-currency') || 'USD';
    if (!input || !results || !endpoint) return;

    var resultsId = 'oss-predictive-search-results-' + (index + 1);
    results.id = resultsId;
    input.setAttribute('aria-controls', resultsId);

    var debounceId;
    var controller;
    var sequence = 0;

    function hide() {
      window.clearTimeout(debounceId);
      if (controller) controller.abort();
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function allResultsUrl(query) {
      var url = new URL(form.getAttribute('action') || '/search', window.location.origin);
      url.searchParams.set('q', query);
      return url.pathname + url.search;
    }

    function render(query, products) {
      var safeQuery = escapeHtml(query);
      var markup = '';

      if (products.length) {
        markup += '<span class="oss-predictive-search__heading">Suggested products</span>';
        markup += products.map(function (product) {
          var image = product.image || (product.featured_image && product.featured_image.url) || '';
          var imageMarkup = image
            ? '<img class="oss-predictive-search__image" src="' + escapeHtml(image) + '" alt="" loading="lazy">'
            : '<span class="oss-predictive-search__image--fallback" aria-hidden="true"></span>';
          return '<a class="oss-predictive-search__item" role="option" href="' + escapeHtml(product.url || '#') + '">' +
            imageMarkup +
            '<span class="oss-predictive-search__copy"><span class="oss-predictive-search__title">' + escapeHtml(product.title) + '</span></span>' +
            '<span class="oss-predictive-search__price">' + escapeHtml(priceLabel(product, currency)) + '</span>' +
          '</a>';
        }).join('');
      } else {
        markup += '<div class="oss-predictive-search__empty">No matching products yet.</div>';
      }

      markup += '<a class="oss-predictive-search__all" href="' + escapeHtml(allResultsUrl(query)) + '">View all results for &quot;' + safeQuery + '&quot;</a>';
      results.innerHTML = markup;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(query) {
      var currentSequence = ++sequence;
      if (controller) controller.abort();
      controller = new AbortController();
      var url = new URL(endpoint, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');

      fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.json();
        })
        .then(function (data) {
          if (currentSequence !== sequence) return;
          var products = data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
            ? data.resources.results.products
            : [];
          render(query, products);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (currentSequence !== sequence) return;
          render(query, []);
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(debounceId);
      if (query.length < 2) {
        hide();
        return;
      }
      debounceId = window.setTimeout(function () {
        search(query);
      }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.hidden) search(input.value.trim());
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        hide();
        input.blur();
      }
    });

    document.addEventListener('pointerdown', function (event) {
      if (!form.contains(event.target)) hide();
    });
  }

  function start() {
    document.querySelectorAll('[data-oss-predictive-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
